import Dashboard             from "views/Dashboard.js";
import AccessRequests        from "views/AccessRequests.js";
import UserProfile           from "views/UserProfile.js";
import Datatable             from "views/Datatable.js";
import ScatterPlot           from "views/ScatterPlot.js";
import Linechart             from "views/Linechart.js";
import Geography             from "views/Geography.js";
import ReadHits              from "views/ReadHits.js";
import ContigHits            from "views/ContigHits.js";
import SequenceAlignmentpage from "views/SequenceAlignmentpage.js";

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "bi-grid-3x3-gap",
    component: Dashboard,
    layout: "/pass",
    showInSidebar: true,
  },
  {
    path: "/datatable",
    name: "Interactive DataTable ",
    subtitle: "Dynamic Data Table for Real-Time Filtering",
    icon: "bi-table",
    component: Datatable,
    layout: "/pass",
    showInSidebar: true,
  },
  {
    path: "/linechart",
    name: "Process Run Timeline",
    subtitle: "Interactive LineCharts for Real-Time Comprehensive Data Trends Over Time",
    icon: "bi-graph-up",
    component: Linechart,
    layout: "/pass",
    showInSidebar: true,
  },
  {
    path: "/ScatterPlot",
    name: "Dynamic ScatterPlots",
    subtitle: "Comprehensive Scatter Plot for Real-Time Bioinformatics Data Exploration for Read Hits and Contig Hits",
    icon: "bi-diagram-3",
    component: ScatterPlot,
    layout: "/pass",
    showInSidebar: true,
  },
  {
    path: "/geography",
    name: "Geography",
    subtitle: "",
    icon: "bi-globe",
    component: Geography,
    layout: "/pass",
    showInSidebar: true,
  },
  {
    path: "/access-requests",
    name: "Access Requests",
    icon: "bi-person-check",
    component: AccessRequests,
    layout: "/pass",
    showInSidebar: true,
    adminOnly: true,
  },
  {
    path: "/user",
    name: "User Profile",
    icon: "bi-person-circle",
    component: UserProfile,
    layout: "/pass",
    showInSidebar: true,
  },
  {
    path: "/ReadHits",
    name: "Read Hits",
    component: ReadHits,
    layout: "/pass",
    showInSidebar: false,
  },
  {
    path: "/ContigHits",
    name: "Contig Hits ",
    component: ContigHits,
    layout: "/pass",
    showInSidebar: false,
  },
];

export default dashboardRoutes;
